import gql from "graphql-tag";

export const GET_PRESENTATION_LIST = gql`
  query GetPresentations(
    $options: GetManyOptions
    $filter: PresentationFilterInput
  ) {
    getPresentations(options: $options, filter: $filter) {
      content {
        country
        createdAt
        id
        name
        status
        updatedAt
        year
        type
      }
      count
      limit
      skip
    }
  }
`;

export const GET_COSTUMETYPES = gql`
  query GetFullCostumeFeatureInventories(
    $filters: FeatureInvInput
    $options: GetManyOptions
  ) {
    getFullCostumeFeatureInventories(filters: $filters, options: $options) {
      content {
        presentation {
          id
          name
        }
        id
        name
        isCommon
        note
        updatedAt
      }
      count
      limit
      skip
    }
  }
`;
